'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeadGenForm = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reduxForm = require('redux-form');

var _reactIntl = require('react-intl');

var _verify = require('helpers/verify');

var _FormFields = require('components/FormFields');

var _colors = require('constants/colors');

var _LeadGenForm = require('./LeadGenForm.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messages = (0, _reactIntl.defineMessages)({
  email: {
    id: 'leadgen.email',
    defaultMessage: 'Email address'
  },
  location: {
    id: 'leadgen.location',
    defaultMessage: 'City name'
  }
});

var LeadGenForm = exports.LeadGenForm = function (_Component) {
  (0, _inherits3.default)(LeadGenForm, _Component);

  function LeadGenForm() {
    var _ref;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, LeadGenForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = LeadGenForm.__proto__ || (0, _getPrototypeOf2.default)(LeadGenForm)).call.apply(_ref, [this].concat(args))), _this2), _this2.handleSubmit = function (_ref2) {
      var email = _ref2.email,
          location = _ref2.location;
      var _this$props = _this.props,
          onWaitlistRequest = _this$props.onWaitlistRequest,
          submissionType = _this$props.submissionType;


      onWaitlistRequest({
        email: email,
        submissionType: submissionType,
        location: location
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(LeadGenForm, [{
    key: 'renderError',
    value: function renderError() {
      var error = this.props.formError || {};

      var errorMessage = void 0;
      if (typeof error === 'string') {
        errorMessage = error;
      } else if (error.code === _LeadGenForm.CODE_BY_ERROR.ALREADY_ON_WAITLIST) {
        errorMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'leadgen.existingLead',
          defaultMessage: 'We love your enthusiasm \u2014 don\u2019t worry, you\u2019re already on the list!'
        });
      } else if (error.code === _LeadGenForm.CODE_BY_ERROR.ALREADY_MEMBER) {
        errorMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'leadgen.existingAccount',
          defaultMessage: 'Oops! This email is already associated with a ClassPass account. {link}.',
          values: { link: _react2.default.createElement(
              _reactRouter.Link,
              { to: '/login', target: '_self' },
              'Sign in'
            ) }
        });
      } else if (error.defaultMessage) {
        errorMessage = _react2.default.createElement(_reactIntl.FormattedMessage, error);
      } else if (!(0, _verify.isEmpty)(error)) {
        errorMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'leadgen.defaultError',
          defaultMessage: 'Something isn\u2019t working out right now.  Sit tight \u2013 we should be up and running shortly.'
        });
      }

      if (errorMessage) {
        return _react2.default.createElement(
          'p',
          { className: 'lead-gen-form__error' },
          errorMessage
        );
      }
    }
  }, {
    key: 'renderSuccess',
    value: function renderSuccess() {
      return _react2.default.createElement(
        'p',
        { className: 'lead-gen-form__success' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'leadgen.thanks',
          defaultMessage: 'Thanks! You\u2019re officially on the list.'
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          ctaCopy = _props.ctaCopy,
          handleSubmit = _props.handleSubmit,
          hideLocation = _props.hideLocation,
          _props$singleLineBrea = _props.singleLineBreakpoint,
          singleLineBreakpoint = _props$singleLineBrea === undefined ? 'md' : _props$singleLineBrea,
          wasCaptured = _props.wasCaptured,
          intl = _props.intl;


      return _react2.default.createElement(
        'div',
        { className: 'lead-gen-form' },
        _react2.default.createElement(
          'form',
          { method: 'post', onSubmit: handleSubmit(this.handleSubmit) },
          _react2.default.createElement(
            'div',
            { className: 'grid' },
            _react2.default.createElement(
              'div',
              { className: 'grid__item ' + singleLineBreakpoint + '-2/5 pb-' },
              _react2.default.createElement(_reduxForm.Field, {
                component: _FormFields.InputField,
                name: 'email',
                suppressErrorMessage: true,
                inputAttributes: {
                  disabled: wasCaptured,
                  placeholder: intl.formatMessage(messages.email)
                }
              })
            ),
            !hideLocation && _react2.default.createElement(
              'div',
              { className: 'grid__item ' + singleLineBreakpoint + '-2/5 ' + singleLineBreakpoint + '-pl pb' },
              _react2.default.createElement(_reduxForm.Field, {
                component: _FormFields.LocationInputField,
                format: null,
                name: 'location',
                suppressErrorMessage: true,
                inputAttributes: {
                  disabled: wasCaptured,
                  placeholder: intl.formatMessage(messages.location)
                }
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'grid__item ' + singleLineBreakpoint + '-1/5 ' + singleLineBreakpoint + '-pl' },
              _react2.default.createElement(
                'button',
                {
                  type: 'submit',
                  className: _colors.CTA_COLOR_BY_NAME.primary_solid + ' bt--width-full',
                  disabled: wasCaptured
                },
                ctaCopy || _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'leadgen.submit',
                  defaultMessage: 'Submit'
                })
              )
            )
          )
        ),
        wasCaptured ? this.renderSuccess() : this.renderError()
      );
    }
  }]);
  return LeadGenForm;
}(_react.Component);

LeadGenForm.propTypes = {
  intl: _reactIntl.intlShape.isRequired,
  ctaCopy: _propTypes2.default.string,
  formError: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  handleSubmit: _propTypes2.default.func.isRequired,
  hideLocation: _propTypes2.default.bool,
  submissionType: _propTypes2.default.string,
  onWaitlistRequest: _propTypes2.default.func.isRequired,
  singleLineBreakpoint: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'retina', 'none']),
  wasCaptured: _propTypes2.default.bool
};